import { render, staticRenderFns } from "./NotificationsBadge.vue?vue&type=template&id=8f075754"
import script from "./NotificationsBadge.vue?vue&type=script&lang=js"
export * from "./NotificationsBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports